export default window._cmsContent['whd/england-wales-screen']